import { Component, OnInit, Input } from '@angular/core';
import { ServiceResult } from '../service-result.model';
import { serviceProviderTypeDescriptions } from '../../service-provider-type.enum';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import { IdentityService } from 'src/app/security/identity.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { InitialContactDialogComponent } from 'src/app/contact/initial-contact-dialog/initial-contact-dialog.component';
import { InitialContactDialogData } from 'src/app/contact/initial-contact-dialog/initial-contact-dialog.model';
import { Contact } from 'src/app/contact/contact.model';
import { ContactService } from 'src/app/contact/contact.service';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SocialMediaShareComponent } from './social-media-share/social-media-share.component';


@Component({
  selector: 'app-service-result',
  templateUrl: './service-result.component.html',
  styleUrls: ['./service-result.component.scss']
})
export class ServiceResultComponent implements OnInit
{
  @Input() public result: ServiceResult;
  profileCompleted$: Observable<boolean>;

  constructor (
    private storage: AngularFireStorage,
    public identity: IdentityService,
    private contactDialog: MatDialog,
    private contactService: ContactService,
    private router: Router,
    private bottomSheet: MatBottomSheet
  ) { }

  public profileURL$: Observable<string>;
  public contact$: Observable<Contact>;

  public ngOnInit(): void
  {
    if (!!this.result.service.imageId)
    {
      this.profileURL$ = this.storage
        .ref(`service-provider-profiles/${this.result.service.imageId}`)
        .getDownloadURL();
    } else
    {
      this.profileURL$ = this.storage
        .ref(`unknown-profile.jpg`)
        .getDownloadURL();
    }

    this.contact$ = this.identity.userKey$.pipe(
      switchMap(userKey =>
        this.contactService.getContactByKey(this.result.documentKey, userKey)
      )
    );

    this.profileCompleted$ = this.identity.userProfileComplete$;
  }

  get type(): string
  {
    return serviceProviderTypeDescriptions[this.result.service.type]
      .description;
  }

  openContactDialog()
  {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.autoFocus = true;
    dialogConfig.minWidth = '30vw';
    dialogConfig.maxHeight = '70vh';
    dialogConfig.panelClass = 'my-panel';

    this.identity.userKey$.subscribe(userKey =>
    {
      dialogConfig.data = new InitialContactDialogData({
        serviceDocumentKey: this.result.documentKey,
        clientUserKey: userKey
      });

      const dialogRef = this.contactDialog.open(
        InitialContactDialogComponent,
        dialogConfig
      );

      dialogRef.afterClosed().subscribe(dialogResult =>
      {
        if (!!dialogResult)
        {
          this.router.navigateByUrl(
            `my-contacts/${this.result.documentKey}/${userKey}`
          );
        }
      });
    });
  }

  openShareOptionsPanel(): void
  {
    this.bottomSheet.open(SocialMediaShareComponent);
  }
}
